import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file SelectContainer
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import React, { useMemo } from 'react';
import { SelectProvider, useSelect } from '@tencent/glue-react-select';
import { guid } from '@tencent/glue-util-helper';
import { useUncontrolledShow } from '@tencent/glue-react-use';
import { Popper } from '../Popper';
import { SelectPopover } from '../Select/SelectPopover';
import { SelectClickTrigger } from '../Select/SelectClickTrigger';
var SelectPopperContent = Popper.withPopperContent(SelectPopover);
export function MultipleSelectContainer(props) {
  var value = props.value,
      disabled = props.disabled,
      readonly = props.readonly,
      filterOption = props.filterOption,
      onValueChange = props.onValueChange,
      _props$autoClearSearc = props.autoClearSearchValue,
      autoClearSearchValue = _props$autoClearSearc === void 0 ? false : _props$autoClearSearc,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      children = props.children,
      searchable = props.searchable,
      autoAlign = props.autoAlign,
      autoFocusSearch = props.autoFocusSearch,
      zIndex = props.zIndex,
      popoverClassName = props.popoverClassName,
      popoverWidth = props.popoverWidth,
      emptyRender = props.emptyRender,
      emptyContent = props.emptyContent,
      searchPlaceholder = props.searchPlaceholder,
      onSearchChange = props.onSearchChange,
      renderTrigger = props.renderTrigger,
      loading = props.loading,
      renderLoading = props.renderLoading,
      renderFooter = props.renderFooter,
      propsShow = props.show,
      onHide = props.onHide,
      onShow = props.onShow,
      propsOnVisibleChange = props.onVisibleChange,
      defaultShow = props.defaultShow;

  var _useUncontrolledShow = useUncontrolledShow({
    show: propsShow,
    onHide: onHide,
    onShow: onShow,
    onVisibleChange: propsOnVisibleChange,
    defaultShow: defaultShow
  }),
      _useUncontrolledShow2 = _slicedToArray(_useUncontrolledShow, 2),
      show = _useUncontrolledShow2[0],
      onVisibleChange = _useUncontrolledShow2[1];

  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  var select = useSelect({
    value: value !== null && value !== void 0 ? value : [],
    onChange: function onChange(nv) {
      return onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(nv);
    },
    disabled: disabled,
    readonly: readonly,
    filterOption: filterOption,
    autoClearSearchValue: autoClearSearchValue,
    multiple: true,
    extraProps: {}
  });
  var content = {
    searchable: searchable,
    autoAlign: autoAlign,
    autoFocusSearch: autoFocusSearch,
    popoverWidth: popoverWidth,
    emptyRender: emptyRender,
    emptyContent: emptyContent,
    searchPlaceholder: searchPlaceholder,
    onSearchChange: onSearchChange,
    loading: loading,
    renderLoading: renderLoading,
    renderFooter: renderFooter,
    popoverClassName: popoverClassName,
    zIndex: zIndex
  };
  console.log('===== content: ', content);
  return React.createElement(SelectProvider, {
    value: select
  }, React.createElement(Popper, null, React.createElement(SelectClickTrigger, {
    show: show,
    disabled: disabled,
    triggerId: triggerId,
    multiple: true,
    renderTrigger: renderTrigger
  }), React.createElement(SelectPopperContent, _objectSpread(_objectSpread({}, content), {}, {
    show: show,
    onVisibleChange: onVisibleChange,
    getPopper: children,
    arrow: false,
    placement: placement,
    offset: {
      x: 0,
      y: 4
    },
    triggerId: triggerId,
    triggerIds: triggerIds,
    lazyInit: false
  }))));
}